import StatisticsDashboard from "../Views/Statistics/StatisticsDashboard.vue";

export const statisticRoutes = [
    {
        path: "/statistics",
        name: "statistics.index",
        component: StatisticsDashboard,
        meta: {
            menu: {
                parent: 'statistics',
                child: null
            },
            breadcrumb: {
                title: "Statistiques",
                nav: {
                    all: {
                        active: "Statistiques",
                        inactive: []
                    }
                }
            }
        },
    },
];
